import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faArrowsAltH } from '@fortawesome/free-solid-svg-icons';
import labService from './labService'
import './css/Sidebar.css';
import profile from './images/profile_g.png';
import { useNavigate } from 'react-router-dom';
import endpb from "./images/iconsb/endpb.png"
import faqb from "./images/iconsb/faqb.png"
import labb from "./images/iconsb/labb.png"
import walb from "./images/iconsb/walb.png"
import qsarLogo from "./images/qsar_logo_grey.png"
import mib from "./images/iconsb/mib.png"


const Sidebar = ({ active_n, isCollapsed, toggleSidebar }) => {
    const [active, setActive] = useState(active_n);
    const [borbot, setBorbot] = useState(active_n-1);
    const [bortop, setBortop] = useState(active_n+1);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();


    const activeTab = (n, path) => {
        setActive(n)
        setBorbot(n-1)
        setBortop(n+1)
        navigate(path);
    };


    useEffect(() => {
            const fetchUserData = async () => {
                const userData = localStorage.getItem('user');
                if (!userData) {
                    setLoading(false);
                    return;
                }
    
                const parsedUserData = JSON.parse(userData);
                const token = parsedUserData.access;
                if (!token) {
                    setLoading(false);
                    return;
                }
    
                try {
                    const response = await labService.getUserInfo(token);
                    setUser(response.data);
                } catch (error) {
                    console.error('Error fetching user data', error);
                } finally {
                    setLoading(false);
                }
            };
    
            fetchUserData();
        }, []);


    return (
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            <div className={`sidebar-header ${borbot === 0 ? 'border-bot' : ''}`}>
                    <div className='right-div'>
                        <button onClick={toggleSidebar} className="toggle-button">
                            <FontAwesomeIcon icon={faArrowsAltH}/>
                        </button>
                    </div>
                    {user && (      
                            <div className='center-div'>
                                <h3 className={`mar-side-head-name ${isCollapsed === true ? 'hide' : ''}`}>
                                    {user.name || user.surname ? `${user.name || ''} ${user.surname || ''}`.trim() : 'User'}
                                </h3>
                                <div className='profile-picture'><img className="profile" src={profile} alt="profile" /></div>
                                {user.position ? (
                                <>
                                    <p className={`mar-side-head position ${isCollapsed === true ? 'hide' : ''}`}>
                                    {user.position}
                                    </p>
                                    {user.company && (
                                    <p className={`mar-side-head position company-margin ${isCollapsed === true ? 'hide' : ''}`}>
                                        at {user.company}
                                    </p>
                                    )}
                                </>
                                ) : (
                                <p className={`mar-side-head position ${isCollapsed === true ? 'hide' : ''}`}>
                                    {user.email}
                                </p>
                                )}


                            </div>
                    )}
            </div>
            <div className="sidebar-menu">
                <ul className='side-options'>
                    <li className={`${active === 1 ? 'active' : ''} ${borbot === 1 ? 'border-bot' : ''} ${bortop === 1 ? 'border-topr' : ''}`} onClick={() => activeTab(1, '/laboratory')}>
                        <img className="side-icons" src={labb} alt="laboratory" />
                        {!isCollapsed && ' Laboratory'}
                    </li>
                    
                    <li className={`${active === 2 ? 'active' : ''} ${borbot === 2 ? 'border-bot' : ''} ${bortop === 2 ? 'border-topr' : ''}`} onClick={() => activeTab(2, '/home')}>
                        <img className="side-icons" src={endpb} alt="endpoints" />
                        {!isCollapsed && ' Endpoints panel'}
                    </li>

                    <li className={`${active === 3 ? 'active' : ''} ${borbot === 3 ? 'border-bot' : ''} ${bortop === 3 ? 'border-topr' : ''}`} onClick={() => activeTab(3, '/wallet')}>
                        <img className="side-icons" src={walb} alt="wallet" />
                        {!isCollapsed && ' Wallet'}
                    </li>
                    
                    <li className={`${active === 4 ? 'active' : ''} ${borbot === 4 ? 'border-bot' : ''} ${bortop === 4 ? 'border-topr' : ''}`} onClick={() => activeTab(4, '/models-info')}>
                        <img className="side-icons" src={mib} alt="models" />
                        {!isCollapsed && ' Models Information'}
                    </li>
                    {/* Notice we check if bortop is 5, meaning the 4th tab is currently active */}
                    
                </ul>
            </div>
            <div className={`side-filler ${bortop === 5 ? 'border-topr' : ''}`}></div>
            <div className="sidebar-footer">
                
                     <p className='powered'>Powered by</p>    
               
                <img className="qsar-logo" src={qsarLogo} alt="Logo of Qsar" /> 
                
            </div>
        </div>
    );
};

export default Sidebar;
